import type { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames(
  'flex',
  'flex-row',
  'mt-2',
  //'p-2',
  'text-left',
  'rounded',
  'border',
  'border-requirement-border-color',
  'text-requirement-text-color',
  'bg-requirement-background-color',
  'gap-2'
);

interface Props {
  children: ReactNode;
  icon?: Icon;
}

const Requirement = ({ children, icon }: Props) => (
  <div className={className}>
    <div className="flex justify-center items-center bg-requirement-icon-color">
      <span className="text-requirement-text-color p-1.5">
        <IconView icon={icon} size={'lg'} />
      </span>
    </div>
    <div className="flex text-xs items-center py-1.5 pr-1.5">
      <div className="first-letter:capitalize">
        {children!.toString().toLowerCase()}
      </div>
    </div>
  </div>
);

export default Requirement;
